import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveBaraemAnswersRequest } from '../../../services/liferay/baraemServices';
import { configureFirstIframe, isMobileApp } from '../../../utils/util';
import { Loader } from '../../../common/Loader';

const FeedBackForm = ({ setQuestionStep, questions, baraemUsername, hcNumber, questionnaireid, translationMap }) => {
  const [responses, setResponses] = useState({});
  const [isComplete, setIsComplete] = useState(false);
  const [isApiLoading, setIsApiLoading] = useState(false);


  const navigate = useNavigate();

  useEffect(() => {
    setIsComplete(Object.keys(responses).length === questions.length);
  }, [responses, questions]);

  useEffect(() => {

    if (isMobileApp()) {
      configureFirstIframe(1000, 3000, true);
    } else {
      configureFirstIframe(1000, 2200, true);
    }
  }, []);

  if (!questions || questions.length === 0) {
    return <p>Loading questions...</p>;
  }

  const handleResponseChange = (questionId, answer, questionText, questionI18n) => {
    setResponses((prev) => ({
      ...prev,
      [questionId]: {
        answer,
        answertext: "",
        baraemusername: baraemUsername,
        hasConcern: 0,
        hcnumber: hcNumber,
        isactive: 1,
        isFeedback: 1,
        isScheduleAppointment: 0,
        questionid: questionId,
        questionnaireid,
        questiontext: questionText,
        questiontext_i18n: questionI18n || {}
      }
    }));
  };

  const handleSubmit = async () => {
    try {
      if (!isComplete) return;
      const formattedResponses = Object.values(responses);
      // console.log("Feedback Responses:", formattedResponses);
      setIsApiLoading(true);

      let baraemAnswerRequest = {};
      let answerData = formattedResponses;
      baraemAnswerRequest = {
        answerData,
        isFeedback: true,
        hcnumber: hcNumber

      };

      // console.log("feedback response", baraemAnswerRequest);

      const feedbackResponse = await saveBaraemAnswersRequest(baraemAnswerRequest);
      if (feedbackResponse.status === 200) {
        setIsApiLoading(false);

        setQuestionStep(10);
      } else {
        setIsApiLoading(false);


      }

    } catch (error) {
      setIsApiLoading(false);


    }

  };

  if (isApiLoading) {
    return (
      <Loader />);

  }

  return (
    <>
            <div
        className="modal fade Custom_Modal_Box show"
        id="baraemFeedback2"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{ display: "block" }}>
        
                <div className="modal-dialog  CoveragePlan_Dialog3" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="Title_Inner_Box">
                                <h6 className="MainTitleOne">{translationMap?.feedback ?? "Feedback"}</h6>
                            </div>
                        </div>
                        <div className="modal-body feedback-height">
                            <div className="baraem_modal_body">
                                <div className="congrates_inner_box">
                                    <h6 className="Gray_Title">{translationMap?.shareFeedback ?? "Share your feedback"}</h6>
                                    <p className="para_txt1">{translationMap?.thisWillHelpEnhanceServices ?? "This will help us to enhance our services."}</p>
                                    <form className="radio_form">
                                        {questions.map((question, index) =>
                    <div className="question_box" key={question.id}>
                                                <h6 className="Gray_Title">{`${1 + index}- ${question.question}`}</h6>
                                                <div className="ans_option_box">
                                                    <div className="radio_box">
                                                        <input
                            type="radio"
                            id={`optionAgree${question.id}`}
                            name={`radio-group${question.id}`}
                            onChange={() =>
                            handleResponseChange(
                              question.id,
                              "Agree",
                              question.question,
                              question.question_i18n
                            )
                            } />
                          
                                                        <label htmlFor={`optionAgree${question.id}`}>{translationMap?.agree ?? "Agree"}</label>
                                                    </div>
                                                    <div className="radio_box">
                                                        <input
                            type="radio"
                            id={`optionNeutral${question.id}`}
                            name={`radio-group${question.id}`}
                            onChange={() =>
                            handleResponseChange(
                              question.id,
                              "Neutral",
                              question.question,
                              question.question_i18n
                            )
                            } />
                          
                                                        <label htmlFor={`optionNeutral${question.id}`}>{translationMap?.neutral ?? "Neutral"}</label>
                                                    </div>
                                                    <div className="radio_box">
                                                        <input
                            type="radio"
                            id={`optionDisagree${question.id}`}
                            name={`radio-group${question.id}`}
                            onChange={() =>
                            handleResponseChange(
                              question.id,
                              "Disagree",
                              question.question,
                              question.question_i18n
                            )
                            } />
                          
                                                        <label htmlFor={`optionDisagree${question.id}`}>{translationMap?.disagree ?? "Disagree"}</label>
                                                    </div>
                                                </div>
                                            </div>
                    )}
                                    </form>
                                </div>
                            </div>
                            <div className="modal-footer modal_footer_btn_box3">
                                <button
                  type="button"
                  className={
                  isComplete ?

                  "btn blue_btn_link" :
                  "disabled_btn_link"
                  }
                  onClick={handleSubmit}
                  disabled={!isComplete}>

                  
                                    {translationMap?.submit ?? "Submit"}
                                </button>
                                <button
                  type="button"
                  className="btn bluetrans_btn_link"
                  data-dismiss="modal"
                  onClick={() => navigate("/")}>
                  
                                    {translationMap?.close ?? "Close"}
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>);

};

export default FeedBackForm;